/*******************************************************************
* PAGE        : SwitchComponent
* REMARKS     : Comman Switch Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 24-02-2026
********************************************************************/

import React from 'react';
import './SwitchComponent.css';

const SwitchComponent = ({
    label,
    checked,
    onChange,
    error,
    disabled = false,
    style = {},
    ...props
}) => {

    const handleChange = () => {
        if (!disabled) {
            onChange && onChange(!checked); // Toggle the checked state
        }
    };

    return (
        <div className="switch-container" style={style}>
            <div className="switch-wrapper">
                {label && <label className={`switch-label ${error ? 'error' : ''}`}>{label}</label>}
                <div
                    className={`switch ${error ? 'error' : ''} ${disabled ? 'disabled' : ''} ${checked ? 'checked' : ''}`}
                    onClick={handleChange} // Toggle on click
                >
                    <div className={`switch-thumb`}></div> {/* The thumb that moves */}
                </div>
            </div>
        </div>
    );
};

export default SwitchComponent;
